import React from "react";
import { IonBadge, IonIcon, IonText } from "@ionic/react";
import { statusDetail } from "../../../utils/statusDetail";

interface ComponentProps {
  document: any;
}

export const DocumentStatusTag: React.FC<ComponentProps> = ({ document }) => {
  const { statusDigitalSignature }: any = document;
  const statusIcon = statusDetail.find(({ code }) => statusDigitalSignature === code);

  return (
    <IonBadge color={statusIcon?.color}>
      <IonIcon icon={statusIcon?.icon}></IonIcon>
      <IonText class="ion-margin-start">{statusDigitalSignature}</IonText>
    </IonBadge>
  );
};
